import 'bootstrap/dist/css/bootstrap.min.css'
import React, { useEffect, useState } from 'react'
import '../dashboard.css'
import {
    IconButton,
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
} from '@mui/material'
import Avatar from '@mui/material/Avatar'
import { Box, styled } from '@mui/system'
import DeleteIcon from '@mui/icons-material/Delete'
import ModeIcon from '@mui/icons-material/Mode'
import Modal from '@mui/material/Modal'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import TextField from '@mui/material/TextField'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { SimpleCard } from 'app/components'
import axios from 'axios'
import { Apis } from 'app/Apis/Apis'
import { AuthToken } from 'app/auth/AuthToken'
import { StaticData } from 'app/utils/constant'
import AlertDialog from './PromptBox'
import { Container, style, StyledTable } from '../utils/Utils'

function RoleList() {
    const [users, setUsers] = useState([])
    const [rowsPerPage, setRowsPerPage] = React.useState(5)
    const [page, setPage] = React.useState(0)
    const [open, setOpen] = React.useState(false)
    const [openDeleteBox, setOpenDeleteBox] = React.useState(false)
    const [select, setSelect] = useState(0)
    const [deleteId, setDeleteId] = useState()
    const [selectAll, setSelectAll] = useState(false)
    const [userOnSelectAll, setUserOnSelectAll] = useState(0)
    const [filter, setFilter] = useState('')
    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)
    const deleteIdsAll = []

    let config = {
        headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
    }

    const EmptySelectProperty = () => {
        setUserOnSelectAll(0)
        setSelect(0)
        setSelectAll(false)
    }

    const setUsersData = async () => {
        await axios
            .get(`${Apis?.allRole}`, config)
            .then((res) => {
                setUsers(res?.data?.data)
            })
            .catch(() => {})
    }

    useEffect(() => {
        setUsersData()
    }, [])

    const handleChangePage = (event, newPage) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }

    useEffect(() => {}, [select])

    const handleChange = (e) => {
        const { name, checked } = e.target
        if (checked === true) {
            setSelect(select + 1)
            setUserOnSelectAll(userOnSelectAll + 1)
            userOnSelectAll >= 1 ? setSelectAll(true) : console.log('')
        }

        if (checked === false) {
            setSelect(select - 1)
            userOnSelectAll <= 1 ? setSelectAll(false) : console.log('')
            setUserOnSelectAll(userOnSelectAll - 1)
        }

        if (name === 'allSelect') {
            userOnSelectAll >= 1 ? setSelectAll(true) : setSelectAll(!selectAll)
            setUserOnSelectAll(
                userOnSelectAll === 0 && select === 0 ? users.length : 0
            )
            userOnSelectAll === users.length
                ? setSelectAll(false)
                : console.log()
            if (userOnSelectAll === users.length) {
                setSelect(0)
            }
            if (userOnSelectAll < users.length) {
                setSelect(users.length)
            }

            if (
                select === users.length &&
                selectAll === true &&
                userOnSelectAll === 0
            ) {
                setSelect(0)
            }

            let tempUser = users.map((user) => {
                return { ...user, isChecked: checked }
            })
            setUsers(tempUser)
        } else {
            let tempUser = users.map((user) =>
                user._id === name ? { ...user, isChecked: checked } : user
            )
            setUsers(tempUser)
        }
    }

    const deleteDoctor = async () => {
        setTimeout(() => {
            setUsersData()
            EmptySelectProperty()
            users.length <= 1 ? setUsers([]) : console.log('')
        }, 1000)

        await axios
            .delete(`${Apis.deleteUserApi}`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        'accessToken'
                    )}`,
                },
                data: {
                    _id: deleteId?._id,
                },
            })
            .then((res) => {
                console.log(res)
            })
            .catch((err) => {
                console.log('Error in deleteDoctor' + err)
            })
    }

    const deleteAllDoctor = async (e) => {
        try {
            users
                ?.map((i) => {
                    i?.isChecked ? deleteIdsAll.push(i._id) : console.log('')
                })
                .then(async (res) => {
                    console.log(res)
                })
        } catch {
        } finally {
            setTimeout(async () => {
                await axios.delete(`${Apis.deleteUserApi}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem(
                            'accessToken'
                        )}`,
                    },
                    data: {
                        _id: deleteIdsAll,
                    },
                })

                setUsersData()
                EmptySelectProperty()
            }, 200)
            setTimeout(() => {
                setUsers([])
                setUsersData()
            }, 1000)
        }
    }

    const removeData = (data) => {
        setOpenDeleteBox(true)
        setDeleteId(data)
    }

    const promptBoxData = {
        openDeleteBox: openDeleteBox,
        setOpenDeleteBox: setOpenDeleteBox,
        deleteDoctor: deleteDoctor,
        deleteAllDoctor: deleteAllDoctor,
        selectAll: selectAll,
        select: select,
        doctorData: deleteId,
    }

    return (
        <Container>
            <AlertDialog data={promptBoxData} />
            <Box
                sx={{
                    fontWeight: 600,
                    width: '100%',
                    justifyContent: 'space-between',
                }}
            >
                User list
            </Box>
            <Box py="12px" />

            <div className="container my-4" style={{ width: '100%' }}>
                <div
                    className="breadcrumb"
                    style={{ width: '100%', justifyContent: 'end' }}
                >
                    <div>
                        {select >= 2 || selectAll ? (
                            <Button
                                variant="contained"
                                sx={{ marginRight: 2 }}
                                onClick={removeData}
                            >
                                Delete all
                            </Button>
                        ) : (
                            ''
                        )}

                        <Link
                            variant="contained"
                            to={'/dashboard/rolemanagement/addUser'}
                        >
                            <Button variant="contained">Add user</Button>
                        </Link>
                    </div>
                </div>

                <div className="form w-100"></div>

                <SimpleCard title="">
                    <Box>
                        <input
                            type="text"
                            style={{ float: 'right' }}
                            placeholder="Search by name"
                            onChange={(e) => {
                                setFilter(e.target.value)
                            }}
                        />
                    </Box>

                    <Box width="100%" overflow="auto">
                        <StyledTable
                            sx={{ overflowX: 'scroll', minWidth: '60rem' }}
                        >
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            paddingLeft: 20,
                                            width: '20%',
                                        }}
                                    >
                                        {users[0] ? (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        type="checkbox"
                                                        className="form-check-input"
                                                        name="allSelect"
                                                        checked={
                                                            !users.some(
                                                                (user) =>
                                                                    user?.isChecked !==
                                                                    true
                                                            )
                                                        }
                                                        onChange={handleChange}
                                                    />
                                                }
                                            />
                                        ) : (
                                            ''
                                        )}{' '}
                                        Name
                                    </TableCell>
                                    <TableCell>Username</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone number</TableCell>
                                    <TableCell>Role</TableCell>
                                    <TableCell>Address</TableCell>
                                    <TableCell> </TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>
                                {users

                                    ?.filter((name) =>
                                        name.name?.includes(filter)
                                    )
                                    .slice(
                                        page * rowsPerPage,
                                        page * rowsPerPage + rowsPerPage
                                    )
                                    ?.map((subscriber, index) => (
                                        <TableRow key={index}>
                                            <TableCell
                                                align="left"
                                                style={{
                                                    paddingLeft: 20,
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        display: 'flex',
                                                        justifyContent: 'start',
                                                    }}
                                                >
                                                    <FormControlLabel
                                                        className="sadsadsadsadsad"
                                                        control={
                                                            <Checkbox
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                name={
                                                                    subscriber._id
                                                                }
                                                                checked={
                                                                    subscriber?.isChecked ||
                                                                    false
                                                                }
                                                                onChange={
                                                                    handleChange
                                                                }
                                                            />
                                                        }
                                                        label=""
                                                    />

                                                    <Box
                                                        sx={{
                                                            display: 'flex',
                                                            gap: '4px',
                                                        }}
                                                    >
                                                        <Avatar
                                                            onClick={() => {}}
                                                            alt={
                                                                subscriber.name
                                                            }
                                                            src={
                                                                subscriber.image ||
                                                                StaticData.profileImage
                                                            }
                                                        />
                                                        <Link
                                                            style={{
                                                                textDecoration:
                                                                    'none',
                                                                color: 'black',
                                                                paddingTop:
                                                                    '10px',
                                                                position:
                                                                    'relative',
                                                            }}
                                                            to={`/dashboard/profile?_id=${subscriber._id}`}
                                                        >
                                                            {subscriber.name}
                                                        </Link>
                                                    </Box>
                                                </Box>
                                            </TableCell>
                                            <TableCell align="left">
                                                {subscriber.username}
                                            </TableCell>
                                            <TableCell align="left">
                                                {subscriber.email}
                                            </TableCell>
                                            <TableCell>
                                                {subscriber.mobilenumber}
                                            </TableCell>
                                            <TableCell>
                                                {subscriber.role}
                                            </TableCell>
                                            <TableCell>
                                                {subscriber.address}
                                            </TableCell>
                                            <TableCell>
                                                <IconButton
                                                    onClick={() => {
                                                        removeData(subscriber)
                                                    }}
                                                >
                                                    <DeleteIcon />
                                                </IconButton>
                                                <Link
                                                    variant="contained"
                                                    to={`/dashboard/rolemanagement/editUser?_id=${subscriber._id}`}
                                                >
                                                    <IconButton
                                                        onClick={handleOpen}
                                                    >
                                                        <ModeIcon />
                                                    </IconButton>
                                                </Link>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </StyledTable>

                        <TablePagination
                            id="TablePagination"
                            style={{
                                display: 'flex !important',
                                alignItems: 'center !important',
                                justifyContent: 'center !important',
                            }}
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={users.length}
                            rowsPerPage={rowsPerPage}
                            page={page}
                            backIconButtonProps={{
                                'aria-label': 'Previous Page',
                            }}
                            nextIconButtonProps={{
                                'aria-label': 'Next Page',
                            }}
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Box>
                </SimpleCard>
            </div>
        </Container>
    )
}

export default RoleList
